// @ts-ignore
import { GandalfArray } from 'gandalf';
// @ts-ignore
import { GandalfConstantDecorator } from 'gandalf';
// @ts-ignore
import { GandalfLabel } from 'gandalf';
// @ts-ignore
import { GandalfModel } from 'gandalf';
// @ts-ignore
import { GandalfModelBase } from 'gandalf';
// @ts-ignore
import { GandalfProperty } from 'gandalf';
// @ts-ignore
import { GandalfSubRequestLabel } from 'gandalf';
// @ts-ignore
import { GandalfValidator } from 'gandalf';
// @ts-ignore
import * as constants from '../constants';


// @ts-ignore
import { CarePlanItemTemplateResponse } from './care-plan-item-template-response';

// @ts-ignore
import { EncounterTemplateResponse } from './encounter-template-response';

/** See com.rev360.pms.api.controller.admin.dataconfiguration.careplan.CarePlanItemTemplateRecallResponse */
/* istanbul ignore next */
@GandalfModel
export class CarePlanItemTemplateRecallResponse extends CarePlanItemTemplateResponse {

	@GandalfProperty({ designType: Number })
	carePlanItemTemplateId!: number | null;

	@GandalfProperty({ designType: String })
	comments!: string | null;

	@GandalfProperty({ designType: String })
	description!: string | null;

	@GandalfProperty({ designType: EncounterTemplateResponse })
	encounterTemplate!: EncounterTemplateResponse | null;

	@GandalfProperty({ designType: Boolean })
	isCheckoutTask!: boolean | null;

	@GandalfProperty({ designType: Number })
	recallAmount!: number | null;

	@GandalfConstantDecorator(constants.CarePlanItemRecallDuration)
	@GandalfProperty({ designType: constants.CarePlanItemRecallDuration })
	recallUnit!: constants.CarePlanItemRecallDuration | null;

}
